<template>
    <div class="error-msg-wrap">
        <div v-if="loaded" class="form-wrapper slide-up">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <div>
                <h3>Status</h3>
                <select v-model="formData.Status">
                    <option value="Active">Active</option>
                    <option value="Terminated">Terminated</option>
                </select>
                <h3>Name</h3>
                <input type="text" v-model="formData.Name" @input="fieldChange('Name')" />
                <div v-if="formData.Status == 'Terminated'">
                    <h3 style="color:red">Termination Details</h3>
                    <textarea v-model="formData.TerminationDetails"></textarea>
                    <h3 style="color:red">Termination Date</h3>
                    <input type="date" v-model="formData.TerminationDate" />
                </div>
                <h3>Email</h3>
                <input type="text" v-model="formData.Email" @input="fieldChange('Email')" />
                <h3>Phone</h3>
                <phone-input v-model="formData.Phone" @update:modelValue="fieldChange('Phone')" />
                <h3>Team</h3>
                <select v-model="formData.Team">
                    <option v-for="(t, i) in employeeTeams" :key="i" :value="t">{{ t }}</option>
                </select>
                <template v-if="employeeTeams.length > 1">
                    <h3>Additional Teams<info-tip text="Adding additional teams gives this employee access to those teams' scoreboards, the same as their primary team: they can see and update the team's scorecard and rocks metrics." /></h3>
                    <div style="margin-bottom: 20px;max-height:120px;overflow:auto">
                        <template v-for="(t, i) in employeeTeams" :key="i">
                            <div v-if="t != formData.Team" class="checkbox-input">
                                <input type="checkbox" :value="t" v-model="formData.AdditionalTeams" />
                                <div>{{ t }}</div>
                            </div>
                        </template>
                    </div>
                </template>
                <h3 v-if="$store.state.user.isAdmin">Location</h3>
                <select v-if="$store.state.user.isAdmin" v-model="formData.Location" @input="fieldChange('Location')">
                    <option v-for="(l, i) in $store.state.user.locations" :key="i" :value="l">{{ l }}</option>
                </select>
                <h3 v-if="$store.state.user.teamHubRole == 'Admin'">Reporting To</h3>
                <select v-if="$store.state.user.teamHubRole == 'Admin'" v-model="formData.ReportingTo">
                    <option :value="null">No One</option>
                    <option v-for="(e, i) in managerEmployees" :key="i" :value="e.ID">{{ e.Name }}</option>
                </select>
                <div v-for="(f, i) in formData.AdditionalFieldsJSON" :key="i">
                    <h3>{{ f.name }}</h3>
                    <div v-if="f.secure && !f.updating" style="margin-bottom:20px">
                        <a @click="() => { f.oldValue = f.value; f.value = ''; f.updating = true; }">Update</a>
                    </div>
                    <div v-else>
                        <div v-if="f.type == 'text'"><input type="text" v-model="f.value" @input="fieldChange(f.name)" /></div>
                        <div v-if="f.type == 'multitext'"><textarea v-model="f.value" @input="fieldChange(f.name)"></textarea></div>
                        <div v-else-if="f.type == 'date'"><input type="date" v-model="f.value" @change="fieldChange(f.name)" /></div>
                        <div v-else-if="f.type == 'select'">
                            <select v-model="f.value" @change="fieldChange(f.name)">
                                <option v-for="(op, j) in f.options" :key="'o'+j" :value="op">{{ op }}</option>
                            </select>
                        </div>
                        <div v-if="f.secure" style="margin-bottom:20px">
                            <a @click="() => { f.value = f.oldValue; f.updating = false; }">Cancel Update</a>
                        </div>
                    </div>
                </div>
                <div v-if="$store.state.user.teamHubRole == 'Admin'" class="checkbox-input" style="margin-top:15px">
                    <input type="checkbox" v-model="formData.IsManager" />
                    <h3>Is Manager?</h3>
                </div>
                <div class="checkbox-input" style="margin-top:15px">
                    <input type="checkbox" v-model="formData.sendEmail" />
                    <h3>Send Admin Email?</h3>
                </div>
                <input style="margin-top:15px" :class="disableButton ? 'disable-button' : ''" type="submit" value="Submit" @click="submit()" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import axios from 'axios';
import PhoneInput from '@/components/PhoneInput.vue';
import InfoTip from '@/components/InfoTip.vue';
import { normalizePhone, PHONE_ERROR } from '@/phone';

export default defineComponent({
    name: 'AddEditEmployee',
    props: [ 'employeeToEdit', 'employeeFields' ],
    components: {
        PhoneInput,
        InfoTip
    },
    data() {
        return {
            disableButton: false,
            formData: {
                Status: 'Active',
                Name: '',
                Email: '',
                Phone: '',
                Location: '',
                AdditionalFieldsJSON: [] as any,
                TerminationDetails: '',
                TerminationDetailsHTML: '',
                TerminationDate: null as any,
                sendEmail: true,
                changedFields: [] as any,
                IsManager: false,
                ReportingTo: null as any,
                Team: '',
                AdditionalTeams: [] as string[],
                AdditionalTeamsJSON: null as any
            },
            requiredFields: [ 'Name' ],
            loaded: false,
            employeeFieldsClone: [] as any,
            managerEmployees: [] as any,
            employeeTeams: [] as any
        }
    },
    async created() {
        await axios.get(`${this.$store.state.apiUrl}/api/employees/teams`)
            .then(resp => {
                if(resp.data) {
                    this.employeeTeams = resp.data;
                }
            })
            .catch(e => {
                console.log(e);
            })
            
        await axios.get(`${this.$store.state.apiUrl}/api/employees/limitedinfo`)
            .then(resp => {
                this.managerEmployees = resp.data.filter((e: any) => {
                    return e.IsManager;
                })
            })
            .catch(e => {
                console.log(e);
            })
        
        this.employeeFieldsClone = JSON.parse(JSON.stringify(this.$store.state.employeeFields));
        if(this.employeeToEdit) {
            this.formData = JSON.parse(JSON.stringify(this.employeeToEdit));
            this.formData.sendEmail = true;
            this.formData.changedFields = [];
            if(this.formData.TerminationDetails) {
                this.formData.TerminationDetailsHTML = this.formData.TerminationDetails.replace(/\n/g, '<br/>');
            }
            if(this.formData.TerminationDate) {
                this.formData.TerminationDate = this.formData.TerminationDate.split('T')[0];
            }
            this.formData.AdditionalTeams = [];
            if(this.formData.AdditionalTeamsJSON) {
                try {
                    this.formData.AdditionalTeams = JSON.parse(this.formData.AdditionalTeamsJSON);
                } catch(e) {
                    console.log(e);
                }
            }
            if(this.formData.AdditionalFieldsJSON) {
                const additionalFields = JSON.parse(this.formData.AdditionalFieldsJSON);
                this.formData.AdditionalFieldsJSON = [];
                for(const field of this.employeeFieldsClone) {
                    const currentField = additionalFields.find((f: any) => {
                        return f.id == field.id;
                    });
                    if(currentField?.value) {
                        field.value = currentField.value;
                    }
                    this.formData.AdditionalFieldsJSON.push(field);
                }
            } else {
                this.formData.AdditionalFieldsJSON = [];
                for(const field of this.employeeFieldsClone) {
                    this.formData.AdditionalFieldsJSON.push(field);
                }
            }
        } else {
            for(const field of this.employeeFieldsClone) {
                this.formData.AdditionalFieldsJSON.push(field);
            }
        }

        this.loaded = true;
    },
    methods: {
        async submit() {
            for(const requiredField of this.requiredFields) {
                if(!(this.formData as any)[requiredField]) {
                    alert(requiredField + ' is required');
                    return;
                }
            }

            if(this.formData.Status == 'Terminated') {
                if(!this.formData.TerminationDate) {
                    alert('Termination Date is required');
                    return;
                }
                if(!this.formData.TerminationDetails) {
                    alert('Termination Details are required');
                    return;
                }
            }

            const phone = normalizePhone(this.formData.Phone);
            if(!phone) {
                alert(PHONE_ERROR);
                return;
            }
            this.formData.Phone = phone;

            if(this.formData.Email) {
                this.formData.Email = this.formData.Email.trim();
            }

            // the primary team is hidden from the list, so never save it as an additional one
            this.formData.AdditionalTeamsJSON = JSON.stringify(this.formData.AdditionalTeams.filter(t => t != this.formData.Team));

            this.disableButton = true;

            await axios.post(`${this.$store.state.apiUrl}/api/employees`, this.formData)
                .then(resp => {
                    // Terminating someone who still has an admin account
                    if(resp.data?.warning) {
                        alert(resp.data.warning);
                    }
                    this.$emit('close');
                })
                .catch(e => {
                    alert('There was an error')
                    console.log(e);
                })

            this.disableButton = false;
        },
        fieldChange(field: string) {
            if(!this.formData.changedFields.includes(field)) {
                this.formData.changedFields.push(field);
            }
        },
    }
});
</script>
